import { render, staticRenderFns } from "./StepThree.vue?vue&type=template&id=2ed5c9d1&"
import script from "./StepThree.vue?vue&type=script&lang=js&"
export * from "./StepThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed5c9d1')) {
      api.createRecord('2ed5c9d1', component.options)
    } else {
      api.reload('2ed5c9d1', component.options)
    }
    module.hot.accept("./StepThree.vue?vue&type=template&id=2ed5c9d1&", function () {
      api.rerender('2ed5c9d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Wordpress/Installer/StepThree.vue"
export default component.exports